/**
 * Tesco Default Theme
 * @author    Demetrios Yannikakis <demetrios.yannikakis@redboxdigital.com>
 * @copyright Copyright (c) 2020 Redbox Digital (http://www.redboxdigital.com)
 */
define('Magento_Catalog/js/product/list/items',[
    'jquery',
    'jquery/slick',
    'domReady!'
], function ($) {
    'use strict';

    $.widget('redbox.lists', {
        options: {},

        _create: function () {
            this._sliderInit(this.options.carousel);
        },

        _sliderInit: function (id) {
            var cssClassId = '.block.' + id + ' .product-items';

            $(cssClassId).slick({
                "mobileFirst": true,
                "slidesToShow": 1.5,
                "slidesToScroll": 1,
                "arrows": false,
                "dots": true,
                "infinite": false,
                "responsive": [
                    {
                        "breakpoint": 640,
                        "settings": {
                            "slidesToShow": 1.5,
                            "slidesToScroll": 1,
                            "arrows": false,
                            "dots": true,
                            "infinite": false
                        }
                    },
                    {
                        "breakpoint": 768,
                        "settings": {
                            "slidesToShow": 2.5,
                            "slidesToScroll": 2,
                            "arrows": false,
                            "dots": true,
                            "infinite": false
                        }
                    },
                    {
                        "breakpoint": 1008,
                        "settings": {
                            "slidesToShow": 4,
                            "slidesToScroll": 4,
                            "arrows": true,
                            "dots": true
                        }
                    }
                ]
            });

            $('.product-item-promo').on('click', function() {
                if (id ===  'related' || id === 'upsells') {
                    var content = $(this).find('.product-item-dialog');
                    content.css('margin-top', -content.outerHeight() - $(this).outerHeight());
                    content.toggle();
                }
            });

            this._equalHeights('.products.product-items', '.product-item-name');
            this._equalHeights('.products.product-items', '.product-item-promo');
            this._equalHeights('.products.product-items', '.product-item');
        },

        _equalHeights: function (items, item) {
            $(items).each(function(){
                var highestBox = 0;

                $(this).find(item).each(function(){
                    if($(this).height() > highestBox){
                        highestBox = $(this).height();
                    }
                })

                $(this).find(item).height(highestBox);
            });
        }
    });

    return $.redbox.lists;

});

